import React, {useEffect, useState} from "react";
import {Button, Drawer, Form, Input, Select, TreeSelect, Checkbox} from "antd";
import {useModel} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const PositionForm = () => {
    const [batchInsert, setBatchInsert] = useState(false);
    const [areaVal, setAreaVal] = useState("");
    const [shelfVal, setShelfVal] = useState("");
    const [{materialSortDict}, {getMaterialSortDict}] = useModel("cmDict");
    const [{userInfo}] = useModel("global");

    useEffect(() => {
        getMaterialSortDict();
    }, []);
    // useEffect(()=>{
    //     setBatchInsert(false)
    // })
    const [form] = Form.useForm();
    const [
        {areaList, shelveList, idshelveList,positionActionType, selectedWarehouse, selectedPosition},
        {insertPosition, updatePosition, loadPosition,batchInsertShelfs, setPositionDrawerVisible,loadIdShelve}
    ] = useModel("warehouse");

    useEffect(() => {
        if (positionActionType === CM_ACTION_TYPE.INSERT) {
            form.resetFields();
            form.setFieldsValue({warehouseName: !!selectedWarehouse ? selectedWarehouse.warehouseName : ""});
        } else if (positionActionType === CM_ACTION_TYPE.EDIT) {
            form.resetFields();
            form.setFieldsValue(selectedPosition);
            // console.log(selectedPosition)
            let data = {
                pageSize:1000,
                pageNum:1,
                "warehouseId": selectedWarehouse.id,
                "orgId": userInfo.orgId,
                "areaId": selectedPosition.areaId,          
            }
            loadIdShelve({showMsg:false,data})         
        }
    }, [positionActionType, selectedWarehouse, selectedPosition]);

    const onFinish = () => {
        if (positionActionType === CM_ACTION_TYPE.INSERT) {
            form.validateFields().then(async data => {
                data.warehouseId = selectedWarehouse.id;
                data.orgId = userInfo.orgId;
                data.orgName = userInfo.orgName;
                if(batchInsert){
                    await batchInsertShelfs({showMsg: true, data});
                    loadPosition({showMsg: false, data: {warehouseId: selectedWarehouse.id,pageSize: 10,pageNum:1}});
                    setBatchInsert(false)  
                    form.setFieldsValue({isBatch:false})
                    setPositionDrawerVisible(false)
                                     
                }else{
                    await insertPosition({showMsg: true, data});
                    loadPosition({showMsg: false, data: {warehouseId: selectedWarehouse.id,pageSize: 10,pageNum:1}});
                    setBatchInsert(false)                    
                    form.setFieldsValue({isBatch:false})
                    setPositionDrawerVisible(false)
                }

            });
        } else if (positionActionType === CM_ACTION_TYPE.EDIT) {
            form.validateFields().then(async data => {
                data.id = selectedPosition.id         
                data.orgId = userInfo.orgId;
                data.orgName = userInfo.orgName;
                await updatePosition({showMsg: true, data});
                loadPosition({showMsg: false, data: {warehouseId: selectedWarehouse.id,pageSize: 10,pageNum:1}});
                setPositionDrawerVisible(false);
            });
        }
    }

    const onReset = () => {
        form.resetFields();
        form.setFieldsValue({warehouseName: !!selectedWarehouse ? selectedWarehouse.warehouseName : ""});
        if(positionActionType === CM_ACTION_TYPE.INSERT){

        }else if(positionActionType === CM_ACTION_TYPE.EDIT){
            let {areaId,shelvesId} = selectedPosition
            form.setFieldsValue({areaId,shelvesId});
        }

    }

    const onCheck = e => {
        setBatchInsert(e.target.checked);
    }
    const _filterArea =async (val,option) =>{
        // return console.log(selectedWarehouse)
        let data = {
            pageSize:1000,
            pageNum:1,
            "warehouseId": selectedWarehouse.id,
            "orgId": userInfo.orgId,
            "areaId": val,          
        }
        await loadIdShelve({showMsg:false,data})
        // console.log(res)
        // console.log(idshelveList)
        let fltAreaList = areaList.reduce((con,next)=>{ //这里过滤选中的code
            if(next.id===val){
              con=next.areaCode
            };
            return con;
          },'')
          setAreaVal(fltAreaList)

         form.setFieldsValue({ prefix:`${selectedWarehouse.warehouseCode}${fltAreaList}-`,shelfCode:`${selectedWarehouse.warehouseCode}${fltAreaList}-`,shelvesId:null});
    }    
    const _filterShelf = (val,option) =>{
        let fltShelveList = idshelveList.reduce((con,next)=>{ //这里过滤选中的code
            if(next.id===val){
              con=next.shelvesCode
            };
            return con;
          },'')
        setShelfVal(fltShelveList)
        form.setFieldsValue({ prefix:`${selectedWarehouse.warehouseCode}${areaVal}-${fltShelveList}-`,shelfCode:`${selectedWarehouse.warehouseCode}${areaVal}-${fltShelveList}-`});
    }

    return (
        <Form {...layout} form={form} name="control-hooks"
              onFinish={onFinish}>
            <Form.Item name="warehouseName" label="所属仓库">
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="areaId" label="所属区域" rules={[{required: true, message: '请选择所属区域',}]}>
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="所属区域"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={areaList.map(el => ({label: el.areaName, value: el.id}))}
                    disabled={positionActionType === CM_ACTION_TYPE.EDIT ? true : false}
                    onChange={_filterArea}
                />
            </Form.Item>
            <Form.Item name="shelvesId" label="所属货架" rules={[{required: true, message: '请选择所属货架',}]}>
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="每次选择前先选择上面的所属区域"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={idshelveList.map(el => ({label: el.shelvesName, value: el.id}))}
                    disabled={positionActionType === CM_ACTION_TYPE.EDIT ? true : false}
                    onChange={_filterShelf}
                    notFoundContent="请先点击上面的所属区域"
                />
            </Form.Item>
            {/* <Form.Item name="materialType" label="配件类型">
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    placeholder="请选择商品类别"
                    treeDefaultExpandAll
                    onChange={() => {
                    }}
                    treeData={materialSortDict}
                    
                />
            </Form.Item> */}
            <Form.Item name="isBatch" label="批量录入" valuePropName="checked">
                <Checkbox checked={batchInsert} disabled={positionActionType === CM_ACTION_TYPE.EDIT ? true : false} onChange={onCheck}/>
            </Form.Item>
        
            {batchInsert ? (
                <>
                    <Form.Item name="prefix" label="前缀">
                        <Input/>
                    </Form.Item>
                    <Form.Item name="startCode" label="起始编码">
                        <Input/>
                    </Form.Item>
                    <Form.Item name="shelfNumber" label="数量">
                        <Input/>
                    </Form.Item>
                </>
            ) : (
                <Form.Item name="shelfCode" label="货位编码" rules={[{required: true, message: '货位编码字段是必输项',}]}>
                    <Input/>
                </Form.Item>
            )}


            <Form.Item name="shelfDesc" label="备注" rules={[{required: false}]}>
                <Input.TextArea/>
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    {positionActionType === CM_ACTION_TYPE.INSERT ? "添加" : "修改"}
                </Button>
                <Button htmlType="button" onClick={onReset} className="margin-left-8">
                    重置
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function () {
    const [{positionDrawerVisible}, {setPositionDrawerVisible}] = useModel("warehouse");
    return (
        <Drawer
            title="货位信息"
            placement="right"
            width={600}
            closable={true}
            onClose={() => {
                setPositionDrawerVisible(false)
            }}
            visible={positionDrawerVisible}
        >
            <PositionForm/>
        </Drawer>
    )
}